import './styles.css';

interface FullScreenLoadingProps {
  isLoading: boolean;
}

export const FullScreenLoading = ({ isLoading }: FullScreenLoadingProps) => {
  return isLoading ? <div className="loading">Loading&#8230;</div> : null;
};
